import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaExternalLinkAlt } from "react-icons/fa"; // Import "Open Web" icon
import "./LegalListing.css";
import WebViewCard from "../../components/commonComponent/WebViewCard";

const API_URL = process.env.REACT_APP_API_URL;

const LegalWebView = () => {
  const [legals, setLegals] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchLegals = async () => {
      const response = await fetch(`${API_URL}/getAllLegals`);
      const data = await response.json();
      console.log(data, "Fetched legals");

      setLegals(data?.data || []);
    };

    fetchLegals();
  }, []);

  return (
    <div className="blog-listing " >
      <div className="blog-container grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {legals.length > 0 ? (
          legals.map((legal) => (
          <WebViewCard  key={legal.id} title={legal.title} path={legal.link} newWindow={true} />
          ))
        ) : (
          <p className="text-gray-600 text-center">Loading legals...</p>
        )}
      </div>
    </div>
  );
};

export default LegalWebView;
